import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getAllFiltersFromQuery, getAllKeysFromQuery } from 'common/filter/utils'
import Applied from 'common/filter/components/applied';

export const mapStateToProps = (state, { resourceName, location }) => {
  return {
    queryKeys: getAllKeysFromQuery(resourceName, location.query),
    filters: getAllFiltersFromQuery(resourceName, location.query)
  };
}

export default withRouter(connect(mapStateToProps)(Applied));



// WEBPACK FOOTER //
// ./common/filter/containers/applied.js